export interface ChallengeSuccess {
  url?: string;
  callBack?: boolean;
}
